import { ComponentProps, ForwardedRef, forwardRef } from 'react'

import cn from '@/utilities/cn'

type ButtonProps = ComponentProps<'button'> & {
  color?: 'primary' | 'warning' | 'secondary' | 'transparent' | 'header' | 'tertiary'
}
export const headerButtonClassName =
  'ml-4 flex items-center rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-brand-400 shadow ring-2 ring-inset ring-brand-400 hover:bg-zinc-50'

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ color, children, className, ...rest }: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    return (
      <button
        ref={ref}
        type={color === 'primary' || color === 'warning' ? 'submit' : 'button'}
        {...rest}
        className={cn(
          'rounded-md px-3 py-2 text-sm sm:mt-0 sm:w-auto',
          {
            'bg-brand-400 hover:bg-brand-300 focus-visible:outline-brand-400': color === 'primary',
            'bg-red-600 hover:bg-red-500 focus-visible:outline-red-600': color === 'warning',
            'font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2':
              color === 'primary' || color === 'warning',
            'bg-white font-semibold text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 hover:bg-zinc-50':
              color === 'secondary',
            'bg-transparent text-zinc-900 hover:bg-zinc-50': color === 'transparent',
            'ml-4 flex items-center rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-brand-400 shadow ring-2 ring-inset ring-brand-400 hover:bg-zinc-50':
              color === 'header',
            'bg-brand-50 text-brand-400 hover:bg-brand-100 focus-visible:outline-brand-200': color === 'tertiary'
          },
          className
        )}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
